import { format } from "date-fns";
import { Button } from "../../../../../../components/Button/Button";
import { CarrotDown } from "../../../../../../icons/CarrotDown";
import {
  PatientRecord,
  TreatmentPlanRecord,
} from "../../../../../../shared/types/types";
import { HorizontalRule } from "../../common/HorizontalRule";
import { RSApprovalFail } from "../../common/RSApprovalFail";
import "../Plan.scss";
import { formatDateTime } from "src/components/common/convertDateTime/convertDateTime";

export interface TreaatmentReportProps {
  patientData: PatientRecord;
  planData: TreatmentPlanRecord;
  dicomDoc: any;
}

export function TreatmentReport({
  patientData,
  planData,
  dicomDoc,
}: TreaatmentReportProps) {
  const casApproval = planData.casApproval;

  const handleSavePDFClick = () => {};

  return (
    <div className="plan-container" data-cy="treatment-report">
      <div className="title">
        Plan Name: {dicomDoc?.dcmPlan?.encrypt_RTPlanName ?? "ERROR"}
      </div>
      <div className="plan-data">
        <div className="data-group">
          <div className="label-and-data">
            <div className="label">Plan Type:</div>
            {/* <div className="data">{patientData?.encrypt_type ?? 'ERROR'}</div> */}
            <div className="data">TREATMENT</div>
          </div>
          <div className="label-and-data">
            <div className="label">Plan Status:</div>
            <div className="data">{planData?.status ?? "ERROR"}</div>
          </div>
          <div className="label-and-data">
            <div className="label">Prescription Dose:</div>
            <div className="data lower-case">{`${null} cGy`}</div>
          </div>
        </div>
        <div className="data-group">
          <div className="label-and-data">
            <div className="label">Treatment Site</div>
            <div className="data">{"N/A"}</div>
          </div>
          <div className="label-and-data">
            <div className="label">Course Name:</div>

            <div className="data">DEFAULT</div>
          </div>
          <div className="label-and-data">
            <div className="label">Treatment Status:</div>
            <div className="data">
              {planData?.casApproval?.approved &&
              dicomDoc?.dcmPlan?.ApprovalStatus === "APPROVED"
                ? "Approved"
                : "Not Approved"}
            </div>
          </div>
        </div>
      </div>
      <HorizontalRule dashed />
      <div className="subtitle">BEAMS</div>
      {dicomDoc?.dcmPlan?.BeamList.map((data: any, index: number) => (
        <div className="beam-data" key={`${data?._id}_${index}`}>
          <div className="data-group">
            <div className="label-and-data">
              <div className="label">Beam Name:</div>
              <div className="data">{data?.encrypt_BeamName}</div>
            </div>
            <div className="label-and-data">
              <div className="label">Collimator:</div>
              <div className="data lower-case">{`${
                data?.CollimatorDiameterMm_double || "0.0"
              } mm`}</div>
            </div>
          </div>
          <div className="data-group">
            <div className="label-and-data">
              <div className="label">Assumed Boron 10:</div>
              <div className="data lower-case">{`${
                data?.PlannedBloodBoronConcentration_double || "0.0"
              } mg/kg`}</div>
            </div>
            <div className="label-and-data">
              <div className="label">Monitor Unit:</div>
              <div className="data">{`${data?.BeamMU_double || "0.0"} MU`}</div>
            </div>
          </div>
        </div>
      ))}

      <HorizontalRule dashed />
      <div className="subtitle">approvals </div>
      <div className="plan-data">
        <div className="data-group">
          <div className="label-and-data">
            <div className="label">Raystation approval:</div>
            <div className="data">
              {dicomDoc?.dcmPlan?.ApprovalStatus === "APPROVED" ? (
                formatDateTime(dicomDoc?.dcmPlan?.encrypt_RTPlanDateTime)
              ) : (
                <RSApprovalFail />
              )}
            </div>
          </div>
          <div className="label-and-data">
            <div className="label">CAS approval:</div>
            <div className={`data `} data-cy="cas-approval-field">
              {casApproval != null && casApproval?.approved
                ? format(
                    new Date(casApproval?.approvedDateTime),
                    "dd-MMM-yyyy HH:mm:ss"
                  )
                : "REQUIRES APPROVAL"}
            </div>
          </div>
        </div>
      </div>
      <div className="controls">
        <Button
          label={"Save PDF"}
          icon={<CarrotDown color="#FFFFFF" />}
          iconPlacement={"left"}
          className={"save-button"}
          onClick={handleSavePDFClick}
          data-cy="save-pdf-button"
        />
      </div>
    </div>
  );
}
